import React, { Component } from 'react'
import { Row, Col, Icon, Button, Radio, InputNumber, Statistic, Select, Spin } from 'antd'
import { app } from '../../app'
import { getResourcePack, messagePay } from './message_api'

const { Option } = Select

class MBuy extends Component {
    constructor (props) {
        super(props)
        this.state = {
            teamList: [],
            specsList: [],
            current_config: {},
            loading: true,
            specsInfo: {},
            buy_count: 1,
        }
    }

    async componentDidMount () {
        this._isMounted = true
        const specsList = await getResourcePack()
        await this.setData({ specsList, specsInfo: specsList[0], loading: false })
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 切换规格
     **/
    handleChangeSpecs = async (e) => {
        await this.setData({ specsInfo: { ...this.state.specsList[e.target.value] } })
    }

    /**
     * 购买
     **/
    handleBuy = async () => {
        const { team, changeSub } = this.props, { specsInfo, buy_count } = this.state
        const flag = await messagePay({
            type: team.type,
            object_name: team.key,
            resource_id: specsInfo.id,
            number: buy_count || 1
        })
        flag && changeSub('1')
    }

    render () {
        let { team } = this.props, { specsList, loading, specsInfo, buy_count } = this.state
        return (
            <div className="message-buy-page">
                <div className="mbp-intro">
                    <Icon type="info-circle"/>
                    <div>
                        <div>短信套餐包可充值到省级帐号和队伍帐号，省级帐号的短信套餐包可以发送短信到全省队员的有效号码，队伍帐号的短信套餐包可以发送到短信到全队队员的有效号码。</div>
                        <div><span className="pi-red">禁止发送金融相关的所有内容</span>，请客户请谨慎购买。</div>
                        <div>短信套餐包过期不可使用，已使用套餐包剩余资源不支持退订。</div>
                    </div>
                </div>
                <div className="eb-content">
                    <div className="eb-items">
                        <dl className="mbp-card">
                            <dt className="pc-head"><span>基本配置</span></dt>
                            <dd className="pc-body">
                                <Spin spinning={loading} size="large">
                                    <Row className="cb-item">
                                        <Col span={4} className="bi-title">套餐包类型</Col>
                                        <Col span={20}>
                                            <div>
                                                <Button type="primary" size="small">国内通用短信</Button>
                                            </div>
                                            <div className="bi-zhu">
                                                <div>仅可用于国内文本短信，不包括国际及港澳台消息服务</div>
                                                <div>使用短信服务时优先抵用套餐包中的数量</div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="cb-item">
                                        <Col span={4} className="bi-title">资源包规格</Col>
                                        <Col span={20}>
                                            <Radio.Group defaultValue={0} buttonStyle="solid" size="small"
                                                         className="no-select"
                                                         onChange={this.handleChangeSpecs}>
                                                {
                                                    specsList.map((s, i) => {
                                                        return (
                                                            <Radio.Button key={'specs-' + s.id}
                                                                          value={i}>{s.name}</Radio.Button>
                                                        )
                                                    })
                                                }
                                            </Radio.Group>
                                        </Col>
                                    </Row>
                                    <Row className="cb-item">
                                        <Col span={4} className="bi-title">购买时长</Col>
                                        <Col span={20}>
                                            <div>
                                                <Button type="primary" size="small">24个月</Button>
                                            </div>
                                            <div className="bi-zhu">套餐包购买成功后，由超管审核通过即刻生效，到期后失效</div>
                                        </Col>
                                    </Row>
                                </Spin>
                            </dd>
                        </dl>
                        <dl className="mbp-card">
                            <dt className="pc-head"><span>购买信息</span></dt>
                            <dd className="pc-body">
                                <Row className="cb-item">
                                    <Col span={4} className="bi-title">购买数量</Col>
                                    <Col span={20}>
                                        <InputNumber className="it-number" size="large" defaultValue={1} min={1}
                                                     precision={0}
                                                     onChange={v => this.setData({ buy_count: v })}/>
                                    </Col>
                                </Row>
                            </dd>
                        </dl>
                    </div>
                    <div className="mbp-current">
                        <div className="pc-head">当前配置</div>
                        <div className="pc-body">
                            <Row className="cb-item">
                                <Col span={10} className="bi-title">套餐包类型:</Col>
                                <Col span={14}>国内通用短信套餐包</Col>
                            </Row>
                            <Row className="cb-item">
                                <Col span={10} className="bi-title">资源包规则:</Col>
                                <Col span={14}>{specsInfo.name || ' - '}</Col>
                            </Row>
                            <Row className="cb-item">
                                <Col span={10} className="bi-title">购买对象:</Col>
                                <Col span={14}>
                                    {team.type === 1 ? '队 · ' : (team.type === 2 ? '省 · ' : (team.type === 3 ? '国 · ' : ''))}
                                    {team.text || ' - '}
                                </Col>
                            </Row>
                            <Row className="cb-item">
                                <Col span={10} className="bi-title">购买时长:</Col>
                                <Col span={14}>2年</Col>
                            </Row>
                            <Row className="cb-item">
                                <Col span={10} className="bi-title">购买数量:</Col>
                                <Col span={14}>{buy_count}</Col>
                            </Row>
                            <Row className="cb-item">
                                <Col span={10} className="bi-title">配置费用:</Col>
                                <Col span={24} className="bi-money">
                                    <Statistic
                                        prefix={<i className="iconfont icon-renminbi" style={{ color: '#1890ff', fontSize: 42 }}/>}
                                        value={(buy_count || 1) * Number(specsInfo.cost)} precision={2}/>
                                </Col>
                            </Row>
                            <div className="cb-buy">
                                <Button type="primary" onClick={() => this.handleBuy()} block>立即购买</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default MBuy



// WEBPACK FOOTER //
// ./src/routes/message/MBuy.jsx